import React from 'react';

import {Logo as FullLogo} from '@newsela/angelou';

const Logo = () => <FullLogo/>;

export default Logo;
